import { Row, Col, Spin, Typography, Checkbox, Form } from 'antd'
import CustomInput from '../../../components/CustomInput/Input'
import { gstinRules,pincodeRules,cityRules,stateRules,address1Rules,address2Rules } from '../../../helpers/helpers'
import { useSelector, useDispatch } from "react-redux";
import InputWithButton from "../../../components/CustomInput/InputWithButton";
import { TITLE_TXT } from '../../../constants/constants';
import { verifyBusGstin, kycHistory, busVerifyBusGstin, busKycHistory } from '../../../redux/slices/EnqMngtSlice';

const { Text } = Typography;

const KycAddress = ({ kycData, gstin, form, orgId, isReview, token, organizationId }) => {
    const dispatch = useDispatch()
    const { loading, gstinLoading, kycHistoryData } = useSelector((state) => state.enqMngt);
    const { isVerified } = kycHistoryData?.kycDetails?.kycGstinValue || kycData || {};
    const isCommSame = Form.useWatch('commSameAsPrimary', form) ?? false;

    const handleVerifyBtnClick = async (type) => {
        let payload, action;
        if (token) {
            payload = {
                gstin: gstin,
                orgId: organizationId,
                token
            }
            action = busVerifyBusGstin
        } else {
            payload = {
                gstin: gstin,
                orgId
            }
            action = verifyBusGstin
        }
        const response = await dispatch(
            action(payload)
        );
        if (response?.payload?.statusCode === 201) {
            let res;
            if (token) {
                res = await dispatch(busKycHistory({ orgId: organizationId, token }))
            } else {
                res = await dispatch(kycHistory(orgId));
            }
            if (res?.payload?.orgDets?.primaryAddId) {
                form.setFieldsValue({
                    primaryAdd1: res?.payload?.orgDets?.primaryAddLine1,
                    primaryAdd2: res?.payload?.orgDets?.primaryAddLine2,
                    primaryCity: res?.payload?.orgDets?.primaryCityName,
                    primaryState: res?.payload?.orgDets?.primaryStateName,
                    primaryPincode: res?.payload?.orgDets?.primaryZipCode,
                });
            }
        }
    }

    const handleCommSameChange = (e) => {
        const checked = e.target.checked;
        if (!form) return;

        if (checked) {
            form.setFieldsValue({
                commAdd1: form.getFieldValue("primaryAdd1"),
                commAdd2: form.getFieldValue("primaryAdd2"),
                commCity: form.getFieldValue("primaryCity"),
                commState: form.getFieldValue("primaryState"),
                commPincode: form.getFieldValue("primaryPincode"),
            });
            return;
        }

        form.setFieldsValue({
            commAdd1: "",
            commAdd2: "",
            commCity: "",
            commState: "",
            commPincode: "",
        });
    };

    return (
        <Spin spinning={loading}>
            <Row gutter={[24, 0]}>
                <Col xs={24} md={12}>
                    <InputWithButton
                        label="Company GSTIN"
                        name="gstin"
                        type="text"
                        isRequired={true}
                        isUpperCase={true}
                        disabled={isVerified}
                        placeholder="Enter your Company GSTIN"
                        rules={gstinRules}
                        verifyBtn={true}
                        verifyLoading={gstinLoading}
                        isVerified={isReview || isVerified}
                        disableVerify={!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstin || "")}
                        handleVerify={() => handleVerifyBtnClick("gstin")}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="Company Address 1"
                        name="primaryAdd1"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isVerified}
                        placeholder="Enter your Address 1"
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="Company Address 2"
                        name="primaryAdd2"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isVerified}
                        placeholder="Enter your Address 2"
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="City"
                        name="primaryCity"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isVerified}
                        placeholder="Enter City"
                        allowLettersOnly
                        rules={cityRules}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="State"
                        name="primaryState"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isVerified}
                        placeholder="Enter State"
                        allowLettersOnly
                        rules={stateRules}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="Pincode"
                        name="primaryPincode"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isVerified}
                        placeholder="Enter Pincode"
                        allowNumbersOnly
                        maxLength={6}
                        rules={pincodeRules}
                    />
                </Col>
            </Row>
            <Form.Item
                name="commSameAsPrimary"
                valuePropName="checked"
                style={{ margin: "16px 0" }}
            >
                <Checkbox disabled={isReview} onChange={handleCommSameChange}>
                    Is communication Address same as Primary Address
                </Checkbox>
            </Form.Item>
            <Text className='kyc-subtitle'>{TITLE_TXT.COMM_ADD}</Text>
            <Row gutter={[24, 0]}>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="Address 1"
                        name="commAdd1"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isCommSame}
                        placeholder="Address 1"
                        rules={address1Rules}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="Address 2"
                        name="commAdd2"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isCommSame}
                        placeholder="Address 2"
                        rules={address2Rules}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="City"
                        name="commCity"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isCommSame}
                        placeholder="Enter City"
                        allowLettersOnly
                        rules={cityRules}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="State"
                        name="commState"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isCommSame}
                        placeholder="Enter State"
                        allowLettersOnly
                        rules={stateRules}
                    />
                </Col>
                <Col xs={24} md={12}>
                    <CustomInput
                        label="Pincode"
                        name="commPincode"
                        type="text"
                        isRequired={true}
                        disabled={isReview || isCommSame}
                        placeholder="Enter Pincode"
                        allowNumbersOnly
                        maxLength={6}
                        rules={pincodeRules}
                    />
                </Col>
            </Row>
        </Spin>
    )
}

export default KycAddress